import { render, staticRenderFns } from "./whiteDetail.vue?vue&type=template&id=78ddba94&scoped=true"
import script from "./whiteDetail.vue?vue&type=script&lang=js"
export * from "./whiteDetail.vue?vue&type=script&lang=js"
import style0 from "./whiteDetail.vue?vue&type=style&index=0&id=78ddba94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ddba94",
  null
  
)

export default component.exports